import React, { useEffect, useRef } from 'react';
import './Hero.scss';
import { gsap } from '../../gsap';
import contents from '../../contents';
import logoImg from '../../Assets/logoLockup.png';
const videoLoopD =
  'https://courageous-cdn-media-bucket.s3.amazonaws.com/lenovo/perfectionFreshHeroLoop.mp4';
const videoLoopM =
  'https://courageous-cdn-media-bucket.s3.amazonaws.com/lenovo/perfectionFreshHeroLoop.mp4';

const heroContent = contents.hero;

function Hero({

  heroBackgroundType,

}) {
  const videoLoopRef = useRef();
  const heroBgType = heroBackgroundType ? heroBackgroundType : contents.hero.background;


  useEffect(() => {
    gsap.fromTo('#logo', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 0.5 });
    gsap.fromTo('#title', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 0.8 });
    gsap.fromTo('#subTitle', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 1.1 });
  }, []);

  useEffect(() => {
    if (heroBgType === 'video') {
      videoLoopRef.current.play();
    }
  }, [heroBgType]);

  return (
    <section className={heroBgType === 'video' ? 'hero' : 'hero hero--image'}>
      {/* <div className="hero__overlay" /> */}
      {heroBgType === 'video' ? (
        <div className="hero--videoLoop">
          <video
            autoPlay
            muted
            playsInline
            loop
            className="hero--videoLoop__video"
            ref={videoLoopRef}
          >
            <source media="(min-width:481px)" src={videoLoopD} type="video/mp4" />
            <source media="(max-width:480px)" src={videoLoopM} type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
      ) : (
        <></>
      )}
      <div className="hero__logo hero__logo--top" id="logo">
        <img
          className="hero__logo__img"
          src={logoImg}
          alt="logo"
        />
      </div>
    </section>
  );
}

export default Hero;
